var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ignore-playSourceContainer",style:({
    width: _vm.setScaleSize(1920),
    height: `${_vm.getScreenHeight()}px`,
    paddingLeft: _vm.setScaleSize(64),
    paddingRight: _vm.setScaleSize(64),
  })},[_c('div',{staticClass:"header",style:({
      fontSize: _vm.setScaleSize(56),
      paddingTop: _vm.setScaleSize(75),
      paddingBottom: _vm.setScaleSize(119),
    })},[_vm._v(" "+_vm._s(_vm.$t('播放列表'))+" ")]),_c('div',{staticClass:"ignore-playSource"},_vm._l((_vm.sourceList),function(item,key){return _c('div',{key:item.id,staticClass:"ignore-sourceItem",style:({
        width: _vm.setScaleSize(780),
        height: _vm.setScaleSize(160),
        borderRadius: _vm.setScaleSize(32),
        paddingLeft: _vm.setScaleSize(66),
        paddingRight: _vm.setScaleSize(66),
        marginBottom: _vm.setScaleSize(40),
        marginLeft: key % 2 == 0 ? 0 : _vm.setScaleSize(200),
      }),on:{"click":function($event){return _vm.handleClick(item)}}},[_c('img',{style:({
          width: _vm.setScaleSize(52),
          height: _vm.setScaleSize(52),
        }),attrs:{"src":require('@/assets/images/playVideo.png')}}),_c('div',{staticClass:"ignore-itemName",style:({
          height: _vm.setScaleSize(67),
          fontSize: _vm.setScaleSize(48),
          lineHeight: _vm.setScaleSize(67),
          marginLeft: _vm.setScaleSize(30),
        })},[_vm._v(" "+_vm._s(_vm.getName(item?.name))+" ")])])}),0),_c('van-dialog',{attrs:{"overlay":false,"showConfirmButton":false,"width":_vm.setScaleSize(302),"height":_vm.setScaleSize(84)},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"playSourceText",style:({
        fontSize: _vm.setScaleSize(32),
        width: _vm.setScaleSize(302),
        height: _vm.setScaleSize(84),
        lineHeight: _vm.setScaleSize(84),
      })},[_vm._v(" "+_vm._s(_vm.$t('视频已播放'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }